module.exports = __webpack_public_path__ + "img/ic-white-info-geral.96f485fc.svg";